/**
 * Path helpers for the Compose module (compositions list and detail).
 */
import { webApi } from '@mi-front/api-clients';

export interface CompositionViewNavigationState {
  composition?: webApi.EnrichedCompositionListItemDto;
}

export const composeRouteGenerator = {
  listForStationSlug: (slug: string) => `/compose/s/${slug}`,
  createForStationSlug: (slug: string) => `/compose/s/${slug}/create`,
  view: (compositionId: string) => `/compose/${compositionId}`,
  edits: (compositionId: string) => `/compose/${compositionId}/edits`,
  publish: (compositionId: string) => `/compose/${compositionId}/publish`,
  /** Social upload wizard for a platform; optional `editId` preselects a video-editor edit. */
  upload: (compositionId: string, platformId: string, editId?: string) => {
    const base = `/compose/${compositionId}/upload/${platformId.toLowerCase()}`;
    return editId ? `${base}?editId=${encodeURIComponent(editId)}` : base;
  },
};
